import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { ITEM_STATUS } from 'domains/internal-request/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * To give nice look on Internal Request `status`.
 * It maps `status` to certain style.
 * @param {string} status Internal Request status
 */
const InternalRequestItemStatusBadge = ({ status }) => {


  const colorMap = {
    [ITEM_STATUS.PENDING]              : 'warning',
    [ITEM_STATUS.PICKED]               : 'success',
    [ITEM_STATUS.REJECTED]             : 'danger',
    [ITEM_STATUS.BORROWED]             : 'primary',
    [ITEM_STATUS.MARKED_FOR_RETURN]    : 'info',
    [ITEM_STATUS.PARTIALLY_RETURNED]   : 'warning',
    [ITEM_STATUS.RETURNED]             : 'success',
    [ITEM_STATUS.PERMANENTLY_BORROWED] : 'primary',
    [ITEM_STATUS.COMPLETED]            : 'success',
    [ITEM_STATUS.CANCELLED]            : 'danger'
  }

  const color = colorMap[status]

  return <StatusBadge color={ color } label={ status } />
}

InternalRequestItemStatusBadge.propTypes = propTypes

export default InternalRequestItemStatusBadge
